import { ButtonBase, styled } from '@mui/material';

export const Container = styled(ButtonBase)`
  justify-content: space-between;
  flex-direction: row;
  background: #f0f0f0;
  border-radius: 4px;
  padding: 8px 16px;
`;
